<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="A7Q"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="VOLUME ONE">
<div class="box"><h1 class="ct_2" id="pz7-1"><a href="#/contenttoc#ba_03" id="ab_03">VOLUME <img alt="" id="APc" role="presentation" src="images/nec-7-1.jpg"/> ONE </a></h1>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?5a12cb62